import { render, staticRenderFns } from "./SendersSmsList.vue?vue&type=template&id=5b6f7110&scoped=true&"
import script from "./SendersSmsList.vue?vue&type=script&lang=js&"
export * from "./SendersSmsList.vue?vue&type=script&lang=js&"
import style0 from "./SendersSmsList.vue?vue&type=style&index=0&id=5b6f7110&scoped=true&lang=scss&"
import style1 from "./SendersSmsList.vue?vue&type=style&index=1&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5b6f7110",
  null
  
)

export default component.exports